/**
 * @generated SignedSource<<b0f6418d4314f75051952c68c54496c6>>
 * @relayHash d16dcc9959b506b8392accd500770cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f7b7a21a1a9179654cb72178fedafb5a03f4255bbb0c9a7341568b3a6d682e3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type handoffConfig_csmAiHubQuery$variables = {
  helpCenterAri: string;
};
export type handoffConfig_csmAiHubQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly " $fragmentSpreads": FragmentRefs<"configuration_AtlassianCsmHandoffConfig">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type handoffConfig_csmAiHubQuery = {
  response: handoffConfig_csmAiHubQuery$data;
  variables: handoffConfig_csmAiHubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "handoffConfig_csmAiHubQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "kind": "LinkedField",
          "name": "csmAi_getAiHubByHelpCenterAri",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "configuration_AtlassianCsmHandoffConfig"
                }
              ],
              "type": "CsmAiHub"
            }
          ]
        },
        "action": "THROW",
        "path": "csmAi_getAiHubByHelpCenterAri"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "handoffConfig_csmAiHubQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "handoffConfigs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "enabled"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "connectorConfiguration",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "message"
                              }
                            ],
                            "type": "CsmAiMessageHandoff"
                          }
                        ]
                      },
                      (v3/*: any*/)
                    ],
                    "type": "CsmAiHandoffConfig"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3f7b7a21a1a9179654cb72178fedafb5a03f4255bbb0c9a7341568b3a6d682e3",
    "metadata": {},
    "name": "handoffConfig_csmAiHubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "841642ca04c73dc56596f8461c555698";

export default node;
